import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap } from 'rxjs';
import * as SharedActions from '@states/shared/shared.actions';
import { CasePreviewAuditActions } from '@states/case-preview-audit/case-preview-audit.actions';
import { CaseManagementService } from '../../services/case-management.service';
import { UtilsService } from '../../edge/utils.service';

@Injectable()
export class CasePreviewAuditEffect {
  public loadAudit$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CasePreviewAuditActions.loadAudit),
      mergeMap(({ filters }) =>
        this.caseManagementService.getPreviewFoldersAudit(filters).pipe(
          map((response) => CasePreviewAuditActions.loadAuditSuccess({ response })),
          catchError((response) => {
            const message = this.utilsService.errMessage(response);
            return [
              CasePreviewAuditActions.loadAuditFail(),
              SharedActions.consoleMessage({ error: message }),
            ];
          }),
        ),
      ),
    ),
  );

  constructor(
    private actions$: Actions,
    private caseManagementService: CaseManagementService,
    private utilsService: UtilsService,
  ) {
  }
}
